import styled from '@emotion/styled';
import { Input } from 'antd';

export const StyledInput = styled(Input)`
	::placeholder {
		color: #6d7478; // placeholder text color to pass contrast test
		opacity: 1;
	}
`;
